import { EmployeeFilesPageDocument } from 'generated/resources/graphql'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import contractVersions from 'modules/contracts/store/collections/contractVersions'
import DocumentURLContext from 'modules/documents/components/Documents/List/DocumentURLContext'
import EmployeeDocumentsDataTable from 'modules/documents/components/EmployeeDocumentsDatatable'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const ListEmployeeFilesPage = () => {
  const { navigation } = useNavigation()
  const { loading, data, error } = useQuery(EmployeeFilesPageDocument, {})

  const { loading: loadingContractVersions } = useAsyncData(
    () => contractVersions.fetch({ withCachedFetchParams: true }),
    []
  )

  const authorized =
    !loading &&
    (data?.documents?._policies?.companyUseCompanyDocuments.can ||
      data?.documents?._policies?.employeeManageAnyEmployeeFolder.can)

  const documentRoutesContext = {
    show: (id: string | number) =>
      navigation.files.employeeFiles.list.documentId.fullPath({ document_id: id }),
  }

  return (
    <DocumentURLContext.Provider value={documentRoutesContext}>
      <ResponsivePage.Body
        variant="full"
        showHeader={false}
        authorized={authorized}
        loading={loading || loadingContractVersions}
        error={error}
        actions={{
          primary: [
            {
              icon: 'settings',
              label: '',
              variant: 'secondary',
              to: navigation.settings.folders.fullPath(),
            },
          ],
        }}
      >
        <EmployeeDocumentsDataTable contractVersions={contractVersions} />
      </ResponsivePage.Body>
    </DocumentURLContext.Provider>
  )
}

export default ListEmployeeFilesPage
